import { create } from 'zustand';

export interface AuthUserProfile {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  role: string;
  tenantId: string;
}

interface AuthState {
  user: AuthUserProfile | null;
  isAuthenticated: boolean;
  setAuth: (user: AuthUserProfile) => void;
  clearAuth: () => void;
  // Legacy compat aliases
  setUser: (user: AuthUserProfile | null) => void;
  login: (user: AuthUserProfile) => void;
  logout: () => void;
}

// NOTE: JWT tokens must NOT be stored in client-side state.
// Supabase manages auth tokens via httpOnly cookies automatically.
export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  isAuthenticated: false,
  setAuth: (user) => set({ user, isAuthenticated: true }),
  clearAuth: () => set({ user: null, isAuthenticated: false }),
  // Legacy compat
  setUser: (user) => set({ user, isAuthenticated: !!user }),
  login: (user) => set({ user, isAuthenticated: true }),
  logout: () => set({ user: null, isAuthenticated: false }),
}));
